
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, Clock, BarChart2, PlusCircle } from 'lucide-react';

type EmptyStateProps = {
  type: 'completed' | 'in-progress' | 'pending';
};

const EmptyState = ({ type }: EmptyStateProps) => {
  const navigate = useNavigate();
  
  let icon;
  let title;
  let description;
  let action;
  
  switch (type) {
    case 'completed':
      icon = <FileText className="h-12 w-12 text-gray-300 mx-auto mb-4" />;
      title = "Inga färdiga analyser ännu";
      description = "När analyser slutförs kommer de att visas här.";
      action = null;
      break;
    case 'in-progress':
      icon = <Clock className="h-12 w-12 text-gray-300 mx-auto mb-4" />;
      title = "Inga pågående analyser";
      description = "När du startar en analys kommer den att visas här.";
      action = null;
      break;
    case 'pending':
      icon = <BarChart2 className="h-12 w-12 text-gray-300 mx-auto mb-4" />;
      title = "Inga väntande analyser";
      description = "Skapa en ny upphandling för att få en analys.";
      action = (
        <Button 
          onClick={() => navigate('/new-procurement')}
          className="mt-4"
        >
          <PlusCircle size={16} className="mr-2" />
          Skapa ny upphandling
        </Button>
      );
      break;
  }
  
  return (
    <Card>
      <CardContent className="text-center py-10">
        {icon}
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        <p className="mt-1 text-gray-500">
          {description}
        </p>
        {action}
      </CardContent>
    </Card>
  );
};

export default EmptyState;
